import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@workspace/ui/components/alert-dialog";

import { describeSendWarning, type SendWarning } from "../send-warnings";

interface SendWarningDialogProps {
	warnings: SendWarning[];
	onAcknowledge: () => void;
}

/**
 * HA-619 AC1 — the won't-print case. Blocking and acknowledgement-only: there is no "cancel",
 * because the items were sent and the warning does not roll that back (AC4). The operator's real
 * action is to tell the kitchen, so the dialog says so rather than offering a button that lies.
 */
export function SendWarningDialog({
	warnings,
	onAcknowledge,
}: SendWarningDialogProps) {
	const open = warnings.length > 0;

	return (
		<AlertDialog open={open}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{warnings.length === 1
							? "This ticket won't print"
							: `${warnings.length} tickets won't print`}
					</AlertDialogTitle>
					<AlertDialogDescription
						render={
							<div>
								<p>
									The items were sent, but there is no printer to print them —
									the kitchen will not see this order unless you tell them.
								</p>
								<ul className="mt-3 list-disc space-y-1 pl-5">
									{warnings.map((warning) => (
										<li key={warning.queueId}>
											{describeSendWarning(warning)}
										</li>
									))}
								</ul>
							</div>
						}
					/>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogAction onClick={onAcknowledge} className="h-14 w-full">
						I&apos;ve told the kitchen
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
